import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onClickOutside"];
import React from 'react';
import ClickOutsideListener from "./ClickOutsideListener";
/**
 * Create a wrapper compose to support click outside functionality functionality
 * @param ComposedComponent
 * @returns {{Component}}
 */

function withClickOutsideListener(ComposedComponent) {
  return function ClickOutsideListenerWrapper(props) {
    var onClickOutside = props.onClickOutside,
        componentProps = _objectWithoutProperties(props, _excluded);

    return /*#__PURE__*/React.createElement(ClickOutsideListener, {
      onClickOutside: onClickOutside,
      className: "d-flex-fill"
    }, /*#__PURE__*/React.createElement(ComposedComponent, componentProps));
  };
}

export default withClickOutsideListener;